// extracted by mini-css-extract-plugin
module.exports = {"attributesInfo":"AttributesInfo_attributesInfo__3chNj"};